// The scopes to sign in with, which depend on the server signing the person in.
//
// The platform's old OAuth server issues a refresh token only for offline_access,
// so it keeps it. Keycloak - recognised by its /realms/ path - must not get it:
// an offline token exchanged straight after sign-in makes Keycloak drop the
// sign-in session, so the next silent sign-in finds none and sends the person
// back to the sign-in screen. Keycloak issues a refresh token without it anyway,
// tied to the sign-in session - which is what a browser application should hold.
export const oidcScope = (authority: string): string =>
  /\/realms\/[^/]+\/?$/.test(authority) ? 'openid' : 'openid offline_access'
